import request from '@/utils/request'

export const newsList = data => request.post('/api/tennis/news', data)

/* *
*网站首页部分配置内容
*/
export const homeContent = () => request.post('/api/tennis/index')

/* *
 *新闻详情
 */
export const newsDetail = data => request.post('/api/tennis/news-detail', data)

/* *
 *二级菜单
 */
export const menus = data => request.post('/api/tennis/menus', data)